import {faAndroid} from "@fortawesome/free-brands-svg-icons/faAndroid";
import {faApple} from "@fortawesome/free-brands-svg-icons/faApple";
import {faChrome} from "@fortawesome/free-brands-svg-icons/faChrome";
import {faFirefoxBrowser} from "@fortawesome/free-brands-svg-icons/faFirefoxBrowser";
import {faInternetExplorer} from "@fortawesome/free-brands-svg-icons/faInternetExplorer";
import {faLinux} from "@fortawesome/free-brands-svg-icons/faLinux";
import {faOpera} from "@fortawesome/free-brands-svg-icons/faOpera";
import {faQq} from "@fortawesome/free-brands-svg-icons/faQq";
import {faSafari} from "@fortawesome/free-brands-svg-icons/faSafari";
import {faWindows} from "@fortawesome/free-brands-svg-icons/faWindows";
import {faYandex} from "@fortawesome/free-brands-svg-icons/faYandex";
import {IconDefinition} from "@fortawesome/pro-solid-svg-icons";
import {faCircleQuestion} from "@fortawesome/pro-solid-svg-icons/faCircleQuestion";
import {faComputer} from "@fortawesome/pro-solid-svg-icons/faComputer";
import {faDesktop} from "@fortawesome/pro-solid-svg-icons/faDesktop";
import {faMobileAlt} from "@fortawesome/pro-solid-svg-icons/faMobileAlt";
import {faTablet} from "@fortawesome/pro-solid-svg-icons/faTablet";
import { faUserSecret } from "@fortawesome/pro-solid-svg-icons/faUserSecret";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {LoginHistoryType, useUserLoginHistory} from "@twigsby/client-data";
import {
    AlertBanner, Button, ContentBlock,
    ContentLoader,
    FlexAlign,
    FlexGap,
    FlexJustify, ListItem,
    ListItemAddon,
    StackHorizontal,
    StackVertical
} from "@twigsby/frontend-framework";
import {FormatLocaleDateTime} from "@twigsby/helpers";
import React, {useEffect, useState} from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import UAParser from "ua-parser-js";
import {useSite} from "../../../Providers/SiteInterfaceProvider";

const agents = [
    'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_5) AppleWebKit/605.1.15 (KHTML, like Gecko) CriOS/85 Version/11.1.1 Safari/605.1.15',
    'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_10_4) AppleWebKit/600.7.12 (KHTML, like Gecko) Version/8.0.7 Safari/600.7.12',
    'Mozilla/5.0 (Linux; Android 4.0.4; Galaxy Nexus Build/IMM76B) AppleWebKit/535.19 (KHTML, like Gecko) Chrome/18.0.1025.133 Mobile Safari/535.19',
    'Mozilla/5.0 (Linux; Android 4.4; Nexus 5 Build/_BuildID_) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/30.0.0.0 Mobile Safari/537.36',
    'Mozilla/5.0 (Linux; Android 5.0.2; SAMSUNG SM-G925F Build/LRX22G) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/4.0 Chrome/44.0.2403.133 Mobile Safari/537.36',
    'Mozilla/5.0 (Linux; U; Android 10; SM-G960F Build/QP1A.190711.020; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/95.0.4638.50 Mobile Safari/537.36 OPR/60.0.2254.59405'
]

const LoginHistory = () => {
    const  currentUserAgent = new UAParser();
    const  testUserAgent = new UAParser(agents[3]);

    const { t } = useTranslation();
    const { currentLocale, updatePageMeta } = useSite();

    const [ currentAgent, setCurrentAgent ] = useState<any>({ debug: null, string: ''});

    const {
        status,
        data,
        error,
    } = useUserLoginHistory();

    const UserDevice = (userAgent: string, userAgentData?: any) => {
        let parser = userAgentData ? null : new UAParser(userAgent);
        let device = parser?.getDevice().model ? parser.getDevice().model : undefined;
/*
        `${currentUserAgent.getDevice().vendor ? `${currentUserAgent.getDevice().vendor} ${currentUserAgent.getDevice().model ? currentUserAgent.getDevice().model : ''} - ` : ''}${currentUserAgent.getBrowser().name} ${currentUserAgent.getBrowser().version} - ${currentUserAgent.getOS().name} ${currentUserAgent.getOS().version}
*/

        return userAgentData && userAgentData.brands.length > 0 ?
            `${userAgentData.model ? userAgentData.model + ' - ' : ''}${userAgentData.brands[0] ? userAgentData.brands[0].brand + ' ' + userAgentData.brands[0].version + ' - ' : ''} ${userAgentData.platform ? userAgentData.platform : ''} ${userAgentData.platformVersion ? userAgentData.platformVersion : ''}` :
            userAgentData ? 'Supported, but no details returned' : `${device ? device + ' - ' : ''}${parser?.getBrowser().name} ${parser?.getBrowser().version} - ${parser?.getOS().name} ${parser?.getOS().version}`;
    }

    const SystemIcon = (userAgent: string, userAgentData?: any): IconDefinition => {
        let parser = userAgentData ? null : new UAParser(userAgent);
        let system = userAgentData ? userAgentData.platform : parser?.getOS().name;

        // AIX, Amiga OS, Android, Arch, Bada, BeOS, BlackBerry, CentOS, Chromium OS, Contiki, Fedora,
        // Firefox OS, FreeBSD, Debian, DragonFly, Gentoo, GNU, Haiku, Hurd, iOS, Joli, Linpus, Linux,
        // Mac OS, Mageia, Mandriva, MeeGo, Minix, Mint, Morph OS, NetBSD, Nintendo, OpenBSD, OpenVMS,
        // OS/2, Palm, PCLinuxOS, Plan9, Playstation, QNX, RedHat, RIM Tablet OS, RISC OS, Sailfish,
        // Series40, Slackware, Solaris, SUSE, Symbian, Tizen, Ubuntu, UNIX, VectorLinux, WebOS,
        // Windows [Phone/Mobile], Zenwalk

        if (system === 'Windows' || system === 'Windows Phone OS') {
            return faWindows
        } else if (system === 'Mac OS' || system === 'iOS') {
            return faApple
        } else if (system === 'Linux') {
            return faLinux
        } else if (system === 'Android') {
            return faAndroid
        } else if (system === 'Chromium OS') {
            return faChrome
        }

        return faUserSecret
    }

    const BrowserIcon = (userAgent: string, userAgentData?: any): IconDefinition => {
        let parser = userAgentData ? null : new UAParser(userAgent);
        let name = userAgentData && userAgentData.brands.length > 0 ? userAgentData.brands[0].brand : parser?.getBrowser().name;

        //Amaya, Android Browser, Arora, Avant, Baidu, Blazer, Bolt, Camino, Chimera, Chrome, Chromium,
        // Comodo Dragon, Conkeror, Dillo, Dolphin, Doris, Edge, Epiphany, Fennec, Firebird, Firefox,
        // Flock, GoBrowser, iCab, ICE Browser, IceApe, IceCat, IceDragon, Iceweasel, IE [Mobile], Iron,
        // Jasmine, K-Meleon, Konqueror, Kindle, Links, Lunascape, Lynx, Maemo, Maxthon, Midori, Minimo,
        // MIUI Browser, [Mobile] Safari, Mosaic, Mozilla, Netfront, Netscape, NetSurf, Nokia, OmniWeb,
        // Opera [Mini/Mobi/Tablet], Phoenix, Polaris, QQBrowser, RockMelt, Silk, Skyfire, SeaMonkey,
        // SlimBrowser, Swiftfox, Tizen, UCBrowser, Vivaldi, w3m, Yandex

        if (name === 'Firefox') { return faFirefoxBrowser }
        else if (name === 'IE') { return faInternetExplorer }
        else if (name === 'Edge') { return faInternetExplorer }
        else if (name === 'Safari' || name === 'Mobile Safari') { return faSafari }
        else if (name === 'Yandex') { return faYandex }
        else if (name === 'Chrome' || name === 'Google Chrome' || name === 'Chromium') { return faChrome }
        else if (name === 'QQBrowser') { return faQq }
        else if (name && name.indexOf('Opera') > -1) { return faOpera }

        return faUserSecret
    }

    const DeviceType = (userAgent: string, userAgentData?: any): IconDefinition => {
        if(userAgentData) {
            return userAgentData.isMobile ? faMobileAlt : faComputer;
        }
        let parser = new UAParser(userAgent);
        let type = parser.getDevice().type;

        //Amaya, Android Browser, Arora, Avant, Baidu, Blazer, Bolt, Camino, Chimera, Chrome, Chromium,
        // Comodo Dragon, Conkeror, Dillo, Dolphin, Doris, Edge, Epiphany, Fennec, Firebird, Firefox,
        // Flock, GoBrowser, iCab, ICE Browser, IceApe, IceCat, IceDragon, Iceweasel, IE [Mobile], Iron,
        // Jasmine, K-Meleon, Konqueror, Kindle, Links, Lunascape, Lynx, Maemo, Maxthon, Midori, Minimo,
        // MIUI Browser, [Mobile] Safari, Mosaic, Mozilla, Netfront, Netscape, NetSurf, Nokia, OmniWeb,
        // Opera [Mini/Mobi/Tablet], Phoenix, Polaris, QQBrowser, RockMelt, Silk, Skyfire, SeaMonkey,
        // SlimBrowser, Swiftfox, Tizen, UCBrowser, Vivaldi, w3m, Yandex

        if (type === 'mobile') { return faMobileAlt }
        else if (type === 'tablet') { return faTablet }
        else { return faDesktop }
    }

    const GetAgentData = () => {
        // @ts-ignore
        if(navigator.userAgentData) {
            // @ts-ignore
            navigator.userAgentData.getHighEntropyValues([
                "model",
                "platform",
                "platformVersion",
            ])
            .then((r: any) => {
                r.brands = r.brands.length > 0 ? r.brands.filter((item: any) => !item.brand.includes('Not') && !item.brand.includes('Chromium')) : r.brands;
                const rexul = `${r.brands.length > 0 && r.brands[0] ? r.brands[0].brand + ' ' + r.brands[0].version : ''} ${r.model ? r.model : ''} ${r.platform ? r.platform : ''} ${r.platformVersion ? r.platformVersion : ''}`;

                setCurrentAgent({ debug: r.brands.length > 0 ? r : null, string: rexul });
            });

        } else {
            setCurrentAgent({ data: null, string: navigator.userAgent });
        }
    }

    const HistoryEntry = (item: LoginHistoryType) => {
        return (
            <ListItem
                title={item.userAgent ? UserDevice(item.userAgent) : 'Unknown'}
                description={`${item.city}, ${item.country} • ${item.ipAddress}`}
                static={true}
                iconContent={{ icon: item.userAgent ? BrowserIcon(item.userAgent) : faCircleQuestion }}
                addonRight={{
                    content: FormatLocaleDateTime(item.loginDate, currentLocale),
                    hideArrow: true
                }}
            />
        )
    }

    useEffect(() => {
        updatePageMeta({
            title: t('settings.loginHistory.title')
        });
    }, [currentLocale]);

    return (
        <StackVertical gap={FlexGap.Small}>

            <StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass={'mb-xs'}>
                <h2 className={'mb-0'}>{t('settings.loginHistory.title')}</h2>
                <Button title={t('settings.loginHistory.actions.checkApi')} onClick={() => GetAgentData() } />
            </StackHorizontal>

            {currentAgent.debug && (
                <AlertBanner
                    title={t('settings.loginHistory.labels.apiViewingWith')}
                    icon={BrowserIcon(currentUserAgent.getUA(), currentAgent.debug)}
                    content={UserDevice(currentUserAgent.getUA(), currentAgent.debug)}
                />
            )}

            <AlertBanner
                title={t('settings.loginHistory.labels.viewingWith')}
                icon={BrowserIcon(currentUserAgent.getUA())}
                content={UserDevice(currentUserAgent.getUA())}
            />

{/*            <AlertBanner
                title={'Currently Viewing With:'}
                icon={BrowserIcon(testUserAgent.getUA())}
                content={`${testUserAgent.getDevice().vendor ? `${testUserAgent.getDevice().vendor} ${currentUserAgent.getDevice().model ? currentUserAgent.getDevice().model : ''} - ` : ''}${testUserAgent.getBrowser().name} ${testUserAgent.getBrowser().version} - ${testUserAgent.getOS().name} ${testUserAgent.getOS().version}`}
            />


            <ListItem developerOption={true} title={window.navigator.userAgent} hideSeparator={true} hideArrow={true} static={true}/>
*/}
            <div className={'card'}>
                <div className={'list-group login-list-group'}>
                    {status === "loading" ? (
                        <ContentLoader childCount={10} childHeight={'7em'}/>
                    ) : status === "error" ? (
                        <ContentBlock error={true} title={error.name} content={error.message} />
                    ) : (
                        <>
                            {data && data.map((item, index) =>
                                <HistoryEntry
                                    key={`loginHistoryItem${index}`}
                                    {...item}
                                />
                            )}
                        </>
                    )}
                </div>
            </div>
        </StackVertical>
    )
}

export default LoginHistory
